export enum ErrorMessages {
  ADJUST_FILTER_ERROR_MESSAGE = 'No data is found for you current selection. Try adjusting the filters',
  SUBSCRIPTION_ERROR_MESSAGE = 'There is no Review data for your subscription',
}

export enum AlertMessages {
  LOWSAMPLE_MESSAGE = 'Low sample size. Please change the filter and try again',
  NODATA_MESSAGE = 'No data found. Please change the filter and try again',
  ERROR_MESSAGE = 'An unexpected error has occurred. If the error continues please contact your GfK Account manager',
  FORBIDDEN_MESSAGE = 'You are not authorised to perform this action',
  FORBIDDEN_ERROR_MESSAGE = 'Not Allowed',
  COLLECTIONS_WARNING = 'Please re-save this insight to your Collections.\nAt least one option in each of the Country and Product Group filters must be selected.',
  SUBSCRIPTIONS_WARNING = 'Data access not available due to missing subscriptions.\nPlease contact your GfK account manager',
  INVALID_VARIABLES_WARNING = 'This chart includes variables that are no longer valid and cannot be used',
  CURRENCY_PRODUCT_WARNING = 'Select one product group to see data.',
  CURRENCY_PRODUCT_COUNTRY_WARNING = 'Select one product group and country to see data.',
}

export enum LoggerMessages {
  SUBSCRIPTIONS_MESSAGE = 'Subscription mismatch',
  INVALID_VARIABLES_MESSAGE = 'Invalid variables',
  COUNTRY_PRODUCT_MESSAGE = 'Missing product/market filter',
}
